var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99998 1.29434e-08H2.39998C1.92259 1.29434e-08 1.46475 0.189642 1.12718 0.527208C0.789618 0.864773 0.599976 1.32261 0.599976 1.8V10.2C0.599976 10.6774 0.789618 11.1352 1.12718 11.4728C1.46475 11.8104 1.92259 12 2.39998 12H9.59998C10.0774 12 10.5352 11.8104 10.8728 11.4728C11.2103 11.1352 11.4 10.6774 11.4 10.2V5.4H7.79998C7.32259 5.4 6.86475 5.21036 6.52718 4.87279C6.18962 4.53523 5.99998 4.07739 5.99998 3.6V1.29434e-08ZM11.4 4.2V4.0968C11.3997 3.61966 11.21 3.16214 10.8726 2.8248L8.57578 0.5268C8.23819 0.189431 7.78044 -5.71807e-05 7.30318 1.29434e-08H7.19998V3.6C7.19998 3.75913 7.26319 3.91174 7.37571 4.02426C7.48823 4.13679 7.64085 4.2 7.79998 4.2H11.4Z",
    fill: "#225FB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiling);
export default __webpack_public_path__ + "static/media/filing.3be58b5c7ed390d1c8a5269f15279541.svg";
export { ForwardRef as ReactComponent };